import { render, staticRenderFns } from "./AtributJenisBarang.vue?vue&type=template&id=7275493e&scoped=true&"
import script from "./AtributJenisBarang.vue?vue&type=script&lang=js&"
export * from "./AtributJenisBarang.vue?vue&type=script&lang=js&"
import style0 from "./AtributJenisBarang.vue?vue&type=style&index=0&id=7275493e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7275493e",
  null
  
)

export default component.exports